const resolveErrors = (err) => {
  switch (err.code) {
    case 'auth/too-many-requests':
      return 'Too many incorrect login attempts. Please try again in a few minutes.'
    case 'auth/wrong-password':
      return 'Incorrect username or password.'
    case 'auth/user-not-found':
      return 'Incorrect username or password.'
    case 'auth/email-already-in-use':
      return 'Email already in use.'
    default:
      console.log(err.code)
      return 'Something went wrong. Please try again.'
  }
}

export default resolveErrors